import React from "react";
import Header from '../Header/Header';
import Footer from "../Header/Footer";

const PrivacyPolicy = () => {
  return (
    <div>
<Header/>
   
    <div style={{ padding: "20px" }}>
      <h1>Privacy Policy</h1>

      <h2>Introduction</h2>
      <p>
        This Privacy Policy describes how <b>Bhantham Matrimony</b> and its
        affiliates (collectively "Bhantham Matrimony, we, our, us") collect,
        use, share, protect or otherwise process your information/personal data
        through our website{" "}
        <a
          href="http://www.bhanthammatrimony.com"
          target="_blank"
          rel="noreferrer"
        >
          www.bhanthammatrimony.com
        </a>{" "}
        (hereinafter referred to as Platform). Please note that you may be able
        to browse certain sections of the Platform without registering with us.
        We do not offer any product/service under this Platform outside India
        and your personal data will primarily be stored and processed in India.
        By visiting this Platform, providing your information or availing any
        product/service offered on the Platform, you expressly agree to be bound
        by the terms and conditions of this Privacy Policy, the Terms of Use and
        the applicable service/product terms and conditions, and agree to be
        governed by the laws of India including but not limited to the laws
        applicable to data protection and privacy. If you do not agree please do
        not use or access our Platform.
      </p>

      <h2>Collection</h2>
      <p>
        We collect your personal data when you use our Platform, services or
        otherwise interact with us during the course of our relationship. Some
        of the information that we may collect includes but is not limited to
        name, date of birth, address, telephone/mobile number, email ID and
        identity proof. Sensitive personal data may include bank account, card
        details, biometric data etc. You may choose not to provide certain
        information, but that could limit your use of certain services. We may
        also track behaviour, preferences, and collect transaction details on
        the Platform. Third-party privacy policies apply when data is collected
        directly by them. Always be careful of fraudulent requests claiming to
        be us.
      </p>

      <h2>Usage</h2>
      <p>
        We use your data to provide requested services, handle and fulfil
        orders, enhance customer experience, resolve disputes, troubleshoot
        problems, inform you about products/services, customise your experience,
        prevent fraud, conduct research, enforce terms, and as described at
        collection time.
      </p>

      <h2>Sharing</h2>
      <p>
        We may share your personal data internally within our group, affiliates,
        business partners, service providers (logistics, payments, rewards,
        etc.). We may disclose personal and sensitive data to government
        agencies or law enforcement if required by law or in good faith belief
        to protect rights, property or safety.
      </p>

      <h2>Security Precautions</h2>
      <p>
        We adopt reasonable security practices to protect data. However, internet
        transmissions are never fully secure. Users must protect their login
        credentials. You can delete your account via profile/settings or by
        writing to us. We may retain some data as required by law or for fraud
        prevention. Data may be anonymised for analytics.
      </p>

      <h2>Your Rights</h2>
      <p>
        You may access, rectify, and update your personal data through platform
        functionalities.
      </p>

      <h2>Consent</h2>
      <p>
        By using our Platform, you consent to our collection and processing of
        your information. You may withdraw consent by contacting the Grievance
        Officer. However, withdrawal may affect services.
      </p>

      <h2>Changes to this Privacy Policy</h2>
      <p>
        We may update this Privacy Policy periodically. Significant changes will
        be notified as per applicable laws.
      </p>

      <h2>Contact Us</h2>
      <p>
        📞 +91 98439 76039 <br />
        📧 info@bhantham.com <br />
        
      </p>
    </div>
    <Footer/>
     </div>
  );
};

export default PrivacyPolicy;
